import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { HUB_API_SETTINGS_TOKEN } from '../../hub-api-settings-token';
import { HubApiSettingsService } from '../../hub-api-settings.service';
import { HandoverReportInput } from '../model/query/handover-report-input';
import { HandoverHistoryReportInput } from '../model/query/handover-history-report-input';
import { HandoverStatusReportInput } from '../model/query/handover-status-report-input';
import { Query } from '../model/query/query';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

// Generated service for communicating with the HandoverReport API endpoint.
@Injectable()
export class HandoverReportEndpointService {

  constructor(
    private http: HttpClient,
    private settingsService: HubApiSettingsService,
  ) {}

  GetHandoverCertificateReport(handoverCertificateInput: HandoverReportInput): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
      body: handoverCertificateInput,
      responseType: 'arraybuffer' as 'arraybuffer',
    };

    return this.http.request(
      'POST',
      this.settingsService.getApiServiceBaseUrl() + 'Reports/Handover/certificate',
      options);
  }

  GetHandoverCertificateReportForDownload(handoverId: string): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
      responseType: 'arraybuffer' as 'arraybuffer',
    };

    return this.http.request(
      'GET',
      this.settingsService.getApiServiceBaseUrl() + 'Reports/Handover/download?handoverId=' + handoverId,
      options);
  }

  HandoverHistory(reportInput: HandoverHistoryReportInput): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
      body: reportInput,
    };

    return this.http.request(
      'POST',
      this.settingsService.getApiServiceBaseUrl() + 'Reports/Handover/handover-history',
      options);
  }

  HandoverStatus(reportInput: HandoverStatusReportInput): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
      body: reportInput,
    };

    return this.http.request(
      'POST',
      this.settingsService.getApiServiceBaseUrl() + 'Reports/Handover/handover-status',
      options);
  }

  GetOffhireCertificateReportForDownload(offHireId: string): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
      responseType: 'arraybuffer' as 'arraybuffer',
    };

    return this.http.request(
      'GET',
      this.settingsService.getApiServiceBaseUrl() + 'Reports/Handover/off-hire/download?offHireId=' + offHireId,
      options);
  }

  GetOffHireCertificateReport(handoverCertificateInput: HandoverReportInput): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
      body: handoverCertificateInput,
      responseType: 'arraybuffer' as 'arraybuffer',
    };

    return this.http.request(
      'POST',
      this.settingsService.getApiServiceBaseUrl() + 'Reports/Handover/off-hire',
      options);
  }
}
